<template>
	<section>
		<!--Toolbar -->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true">        
        <el-form-item>Site:</el-form-item>
				
        <el-form-item>
				  <el-select size='small' style='width:200px' v-model="sitecode" Placeholder='Select Site' @change='startSearch'>
          <el-option v-for="item in codes.sites" 
      		           :key='item.code' 
			 	             :label="item.code + ' - ' + item.name" 
			  	  				 :value='item.code'></el-option>
  		    </el-select>
				</el-form-item>
        
        <el-form-item>
				  <el-select size='small' style='width:160px' v-model="periode" Placeholder='Vanaf periode' @change='startSearch'>
          <el-option v-for="item in codes.periods" 
      		           :key='item.code' 
			 	             :label="item.value" 
			  	  				 :value='item.code'></el-option>
  		    </el-select>
				</el-form-item>
        <!--
        <el-form-item>
          Filter:&nbsp;
				  <el-select size='small' style='width:150px' v-model="searchField" Placeholder='Select field'>
          <el-option v-for="item in searchFields" 
      		           :key='item' 
			 	             :label="item" 
			  	  				 :value='item'></el-option>
  		    </el-select>
				</el-form-item>
				
        <el-form-item>
					<el-input size='small' v-model="searchFilter" placeholder="Search For"  @change='startSearch'></el-input>
				</el-form-item>
				-->
        <el-form-item>
					<el-button type="primary" icon='el-icon-search' size='small' v-on:click="startSearch">Filter</el-button>
				</el-form-item>
        
        <span style='float:right'>
  				<el-form-item>
	  				<el-button type="primary" size="small" icon="el-icon-plus" @click="handleImport">Import</el-button>
		  		</el-form-item>
				</span>
			</el-form>
		</el-col>

		<!--Lijst-->
		<el-table :data="content" stripe highlight-current-row v-loading="listLoading" style="width: 100%;">
      <el-table-column prop="dosid" label="Dossier" width="120" sortable></el-table-column>
      <el-table-column prop="bookperiod" label="Period" width="100" sortable></el-table-column>
      <el-table-column prop="booker" label="Booker" min-width="120" sortable></el-table-column>
      <el-table-column prop="destination" label="Destination" min-width="120" sortable></el-table-column>
      <el-table-column prop="departuredate" label="Departure" width="160" sortable></el-table-column>
      <el-table-column align='right' prop="fin.amount" label="Amount" width="100">
        	<template slot-scope="scope">{{util.formatMoney(scope.row.fin.amount)}}</template>
      </el-table-column>
      <el-table-column prop="bookstatus" label="BS" width="50"></el-table-column>
      <el-table-column prop="loadstatus" label="LS" width="50"></el-table-column>

      <el-table-column label="" width="180" fixed='right'>

				<template slot-scope="scope">
					<el-button type='primary' size="small" icon="el-icon-chat-line-square"  @click="handleView(scope.row)"></el-button>
					<el-button xtype='success' size="small" icon="el-icon-view"  @click="handleXml(scope.row)"></el-button>
					<el-button type='success' size="small" icon="el-icon-edit"  @click="handleEdit(scope.row)"></el-button>

          <el-button disabled type="danger" size="small" icon="el-icon-delete"  @click="handleDel(scope.row)"></el-button>
				</template>
			</el-table-column>
		</el-table>

		<!-- Toolbar -->
		
		<el-col :span="24" class="toolbar">			
      <el-pagination layout="sizes" @current-change="selectPage" :total="mainTotal" style="float:right;"
                     :page-sizes="[10, 15, 25, 50, 100]"  :current-page='currentPage' @size-change="selectPagesize" :page-size="pageSize"></el-pagination>
      <span style='float:right'>
        <span style='font-size:80%;margin-right:4px'>
              {{mainTotal}} records / Page
		    <el-input-number size="mini" v-model='nextPage' :min=1 :max='maxNextValue' @change="loadNextPage" style='width:110px;margin-top:3px' /> of {{pageCount}} </span>
      </span>			
    </el-col>
    
		<!--Wijzig record -->
		<el-dialog :title="editTitle" :visible.sync="editFormVisible" 
                   :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form :model="editForm" label-width="140px" :rules="editFormRules" ref="editForm">
        <el-tabs type="card" style='height:440px' @tab-click="clickTab" v-model='currentTab'>
          <!-- -------------------------------------------------------------------------------------- -->
				  <el-tab-pane name='T1'> 
            <span slot='label'><i class='el-icon-date'></i> Dossier</span>

            <el-form-item label="Dossier/Status : ">
              <el-input style='width:420px' :disabled="this.editMode=='save'" v-model="editForm['dosid']" auto-complete="off"></el-input>
              <el-input style='width:100px;float:right' disabled v-model="editForm['bookstatus']" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="Booker : ">
              <el-input disabled v-model="editForm['booker']" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="Main Dest : ">
              <el-input disabled v-model="editForm['destination']" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="Bookdate : ">
             <el-date-picker disabled style='width:250px;'
                  v-model="editForm['bookdate']" type="datetime" :clearable="true"
                  placeholder="Select Date and Time"
                  format="yyyy-MM-dd"
                  class="startTimeBox">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="Departuredate : ">
              <el-date-picker disabled style='width:250px;'
                  v-model="editForm['departuredate']" type="datetime" :clearable="true"
                  placeholder="Select Date and Time"
                  format="yyyy-MM-dd"
                  class="startTimeBox">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="Returndate : ">
              <el-date-picker disabled style='width:250px;'
                  v-model="editForm['returndate']" type="datetime" :clearable="true"
                  placeholder="Select Date and Time"
                  format="yyyy-MM-dd"
                  class="startTimeBox">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
            <hr color='#eee'>
            </el-form-item>

            <el-form-item label="Dossier Geladen : ">
              <el-date-picker disabled style='width:250px;'
                  v-model="editForm['loaddate']" type="datetime" :clearable="true"
                  placeholder="Select Date and Time"
                  format="yyyy-MM-dd HH:mm:ss"
                  class="startTimeBox">
              </el-date-picker>
            </el-form-item>

            
          </el-tab-pane>
          <!-- -------------------------------------------------------------------------------------- -->
			    <el-tab-pane  name='LOCATE'> <span slot='label'><i class='el-icon-date'></i> Segments</span>
            <el-form-item label="Accommodation : ">
              <el-input rows=8 readonly='readonly' type='textarea' v-model="detailLocate"></el-input>
            </el-form-item>
            <el-form-item label="Transport : ">
              <el-input rows=9 readonly='readonly' type='textarea' v-model="detailTransport"></el-input>
            </el-form-item>
          </el-tab-pane>

          <!-- -------------------------------------------------------------------------------------- -->
			    <el-tab-pane  name='FIN'> <span slot='label'><i class='el-icon-date'></i> Finance</span>
            <el-form-item label="Details : ">
                <el-input rows=8 readonly='readonly' type='textarea' v-model="detailFin"></el-input>
            </el-form-item>
            <el-form-item label="Purchase : ">
                <el-input rows=9 readonly='readonly' type='textarea' v-model="detailPur"></el-input>
            </el-form-item>
    
          <!-- -------------------------------------------------------------------------------------- -->
          </el-tab-pane>
          <!-- -------------------------------------------------------------------------------------- -->

      	</el-tabs>
      
      </el-form>

			<div slot="footer" class="dialog-footer">		  
				<el-button size='small' icon="el-icon-upload2"  @click.native="editFormVisible = false">{{lang.butCancel}}</el-button>
				<el-button size='small' type="primary" icon="el-icon-edit"  @click.native="editSubmit" :loading="editLoading">{{lang.butSave}}</el-button>
			</div>
		</el-dialog>

    <!-- -------------------------------------------------------------------------------------- -->
    <!-- DIALOG VIEW XML                                                                        -->
    <!-- -------------------------------------------------------------------------------------- -->
      
    <el-dialog width='90%' title="View Original XML" :visible.sync="viewXmlVisible" 
                   :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form :model="editForm" label-width="120px">
				<!-- ----------------------------------------------------------------- -->
		     <el-form-item label="Dossier:" prop="dossier">
					<el-input disabled v-model="dossier" auto-complete="off"></el-input>
			  	</el-form-item>
          <el-form-item label="XML File:" prop="id">
					<el-input disabled v-model="xmlfile" auto-complete="off"></el-input>
			  </el-form-item>
        <el-form-item label="XML : "   v-loading="listLoading" >
          <el-input readonly type='textarea' rows='25' style='font-family:system;font-size:12px' v-model="xmldata"></el-input>
        </el-form-item>
		  	<!-- ----------------------------------------------------------------- -->      
				<div style='height:40px'>					
          <el-button style='float:right;' type="primary" @click.native="viewXmlVisible=false" icon="edit" :loading="editLoading">Close</el-button>
        </div>
      </el-form>
		</el-dialog>
    

    <!-- -------------------------------------------------------------------------------------- -->
    <!-- DIALOG VIEW DETAILS                                                                    -->
    <!-- -------------------------------------------------------------------------------------- -->
      
    <el-dialog width='90%' title="View Base Dossier Details" :visible.sync="viewDetailsVisible" 
                   :close-on-click-modal="false" :close-on-press-escape="false">

		  <el-form style='min-height:450px;' :model="editForm" label-width="120px">
	      <el-form-item label="Dossier :" prop="dossier">
					<el-input disabled v-model="dossier" auto-complete="off" style='width:300px'></el-input>
 				  <el-select size='small' style='width:100px;float:Right' v-model="outtype" Placeholder='Select Type' @change='reloadData'>
          <el-option v-for="item in outtypes" 
      		           :key='item' 
			 	             :label="item" 
			  	  				 :value='item'></el-option>
  		    </el-select>
			  </el-form-item>
         <el-form-item label="JSON : "   v-loading="listLoading" >
          <el-input readonly type='textarea' rows='28' style='font-family:system;font-size:12px' v-model="outdata"></el-input>
        </el-form-item>
        <!-- ----------------------------------------------------------------- -->        
				<div style='height:40px'>					
          <el-button style='float:right;' type="primary" @click.native="viewDetailsVisible=false" icon="edit" :loading="editLoading">Close</el-button>
        </div>
			</el-form>
    </el-dialog>			

    <!-- -------------------------------------------------------------------------------------- -->

	</section>
</template>

<script>
  import settings from '../../common/AppSettings';
 	import util     from '../../common/AppUtil';
  import text     from '../../common/AppText';
  import api      from '../../api/bas/dossier';

	export default {
		data() {
			return {
        searchFields: ["Dossier","Booker","Destination","Accommodation"],
        statusList  : [{cd:0,va:"Open"},{cd:1,va:"Processing"},{cd:2,va:"Loaded"},{cd:3,va:"Pushed to Racs"},{cd:5,va:"Load Error"},{cd:6,va:"Push Error"},{cd:9,va:"SKIP this Dossier"}],
        QID         : util.Initialize(this.$router,"Dossier"),
        util        : util,
        stack       : {},
			  lang        : text.data,
        codes       : util.codes,
				pageSize    : settings.pageSize,
 		  	serverPaging: false,
        periode     : "1",
        periodeLast : "1",
        sitecode    : "BC",
        stage       : window.stage,

        currentTab  : "T1",
        pageCount   : 0,
        anonymize   : true,
        //numRecs     : 250,
        sitecode    : "",

        viewXmlVisible: false,
        viewDetailsVisible:false,
 				outtypes    : ["JSON","XML"],
        outtype     : "JSON",
        currentTab  : "T1",
        outdata     : "",
        dossier     : "",
        xmldata     : "",
        xmlfile     : "",

        pageTokens  : [],
        //pageMax     : 0,
        pageLoaded  : false,
        nextPage    : 1,
        maxNextValue: 9999,

				editTitle   : "",
				editMode    : "",
        userDepts   : "",
        userRoles   : "",
				APICode     : "BasDossier",
				mainFunc    : "Dossier",
				mainSubject : "Dossier",
        mainKey     : "dosid",
				mainKeyDesc : "dosid",
        searchFilter: '',				
        content: [],
				counter: {},
				related: [],
				currentPage: 0,
				mainTotal: 0,
        searchField: "Booker",
        detailFin: "",
        detailPur: "",
        detailHist: "",
        detailLocate: "",
        detailFinLoaded: false,      
        detailHistLoaded: false,
        detailLocateLoaded: false,
        detailTransport: "",
		
				listLoading: false,
				editFormVisible: false,// Of de bewerkingsinterface wordt weergegeven
				editLoading: false,
				editForm: {},			
				editFormRules: {
					siteid: [
						{ required: true, message: text.data.mandatory, trigger: 'blur' }
					]
				},

			}
		},
		
		methods: {
 	  	//closeForm: function () {
        //this.selectorVisible = false;
	  		//this.$router.push({name: 'Employees',params: this.stack});
    	//},

		  startSearch: function() {
       if (this.periode.startsWith("."))
        {
          this.periode = this.periodeLast;
        }
        else {
          this.periodeLast = this.periode;
          this.currentPage = 0;
          this.pageTokens = [];
          this.content = [];  
          this.maxNextValue = 9999;
          this.nextPage = 1;
          this.pageCount = 0;
          this.getRecords();
        }
      },

      selectPagesize: function(size) {
				settings.pageSize = size;
        this.currentPage = 0;
        this.nextPage = 1;
        this.pageSize = size;
        this.pageCount = Math.round(this.mainTotal / this.pageSize + 0.5);
        this.getRecords();
			},
      
      selectPage: function(page) {
			},
      
      loadNextPage: function() {
        this.currentPage = this.nextPage - 1;
        this.getRecords();
      },

			// Ophalen record(s) via API
			getRecords() {
				let parg = {};
        parg.Params = {};
        parg.Params.site     = this.sitecode;
        parg.Params.period   = this.periode;
        parg.Params.search   = this.searchFilter;
        parg.Params.field    = this.searchField;
        parg.Params.pageSize = settings.pageSize;

        if (this.currentPage > 0)
          parg.Params.pageToken = this.pageTokens[this.currentPage - 1];        
        
        util.setSessionValue("site",this.sitecode);
        util.setSessionValue("period",this.periode);

				this.listLoading = true;
				
				api.getPagedList(parg).then((res) => {						
          util.processMainResults(res);
          this.codes = util.codes;          
          
          if (this.pageCount == 0) {
            this.mainTotal = util.header["totalRecs"]; 
            this.pageCount = Math.round(this.mainTotal / this.pageSize + 0.5);
          }
          if (this.sitecode == "" && this.codes.sites[0]) this.sitecode = this.codes.sites[0].code;

          if (this.mainTotal > 0)
          {
            var ptok = util.getMainPayload("PageToken");
            if (ptok.length < 5) this.maxNextValue = this.pageTokens.length;

            else this.pageLoaded = false;

            this.pageTokens[this.currentPage] = ptok;
            this.content = util.getMainPayload(this.APICode);
            this.contentSaved = util.getMainPayload(this.APICode);           
          }
					else {
            this.content = [];
            this.contentSaved = [];
          }
          this.listLoading = false;
				})
        .catch((error) => {
          util.serverError(this);
        });

			},

      clickTab: function(tab,event) {
        if (this.currentTab == "FIN" && this.detailFinLoaded  == false) this.openTabDetails("fin");
        else if (this.currentTab == "HIST" && this.detailHistLoaded == false) this.openTabDetails("hist");
        else if (this.currentTab == "LOCATE" && this.detailLocateLoaded == false) this.openTabDetails("locate");
      },

      openTabDetails(loadSet) {
        if (loadSet != "") {
          let parg = {};
          parg.Params = {};
          parg.Params.site    = this.sitecode;
          parg.Params.period  = this.periode;
          parg.Params.search  = this.searchFilter;
          parg.Params.field   = this.searchField;
          parg.Params.dosid   = this.editForm['dosid'];
          parg.Params.currentPage = this.currentPage;
          parg.Params.loadset = loadSet;

          api.execute('findet',parg).then((res) => {		
            var d = res.data;
            if (typeof(d) === "string") d = JSON.parse(res.data);   // convert non-aws string to 
            
            if (loadSet == 'fin') {
              this.detailFin        = d.payload.findet;
              this.detailPur        = d.payload.finpur;
              if (this.detailFin == "") this.detailFin = "- No details -";
              if (this.detailPur == "") this.detailPur = "- No details -";

              this.detailFinLoaded  = true;
            }
            else if (loadSet == 'hist') {
              this.detailHist       = d.payload.findet;
              this.detailHistLoaded = true;
            }
            else if (loadSet == 'locate') {
              this.detailLocate       = d.payload.verblijf;
              this.detailTransport    = d.payload.transport;
              if (this.detailLocate == "") this.detailLocate = "- No details -";
              if (this.detailTransport == "") this.detailTransport = "- No details -";
              this.detailLocateLoaded = true;
            }
          })
          .catch((error) => {
            util.serverError(this);
          });
        
        }
      },

			openRelated: function(row) {       
			},

			// Verwijder
			handleDel: function (row) {
				this.$confirm(text.getText("sdelM",this.mainSubject,row[this.mainKeyDesc]), 'Confirm', {
					type: 'warning',title: text.getText("sdelT",this.mainSubject)
				}).then(() => {
					this.listLoading = true;

				  let parg = {};
          parg.Params = {};
          parg.Params['site'] = row.site;
          parg.Params['dosid'] = row.dosid;

				  api.removeRecord(parg).then((res) => {
						this.listLoading = false;
  					this.$notify({
	  				  title: text.data.conf,type: 'success',
		  				message: text.getText("delOK",this.mainSubject,row[this.mainKey])			  			              
				  	});
						this.getRecords();
					});

				}).catch(() => {

				});
			},
			
			// Display bewerkingsinterface
			handleEdit: function (row) {
        this.editMode = "save";
				this.editTitle = text.getText("modM",this.mainSubject,row[this.mainKey]);
				this.editFormVisible = true;
				this.editForm = Object.assign({}, row);
        this.detailFin = "";
        this.detailPur = "";
        this.detailHist = "";
        this.detailLocate = "";       
        this.detailFinLoaded = false;
        this.detailHistLoaded = false;
        this.detailLocateLoaded = false;
        this.currentTab = "T1";
     
        //this.$nextTick(() => this.$refs.firstEdit.focus());
			},
		  
      handleView: function (row) {
        this.getDetailData(row.dosid);        
			},

      reloadData: function() {
        this.getDetailData(this.dossier);
      },

      getDetailData: function(dosid) {
        let parg = {};
        parg.Params = {};
        parg.Params.site = this.sitecode;
        parg.Params.dosid = dosid;
        this.dossier = dosid;
        parg.Params.period = this.periode;
        parg.Params.search = this.searchFilter;
        parg.Params.field = this.searchField;
        parg.Params.currentPage = this.currentPage;

        //util.Forward(this.$router,"DSV",parg);
        parg.Params["type"] = this.outtype;

        api.execute("detail",parg).then((res) => {	
          var d = res.data;
          if (typeof(d) === "string") d = JSON.parse(res.data);   // convert non-aws string to 
          this.outdata = d.payload.outdata;
          this.viewDetailsVisible = true;
          this.listLoading = false;
				});
      },


      handleXml: function (row) {
        let parg = {};
        parg.Params = {};
        parg.Params.site = this.sitecode;
        parg.Params.dosid = row.dosid;
        parg.Params.period = this.periode;
        parg.Params.search = this.searchFilter;
        parg.Params.field = this.searchField;
        parg.Params.currentPage = this.currentPage;

        ///util.Forward(this.$router,"DSX",parg);
        parg.Params = {};
        parg.Params.site = this.sitecode;
        parg.Params.dosid = row.dosid;
        parg.Params.period = this.periode;
        parg.Params.search = this.searchFilter;
        parg.Params.field = this.searchField;
        parg.Params.currentPage = this.currentPage;
    
				this.listLoading = true;

				api.execute("xml",parg).then((res) => {	
          var d = res.data;
          if (typeof(d) === "string") d = JSON.parse(res.data);   // convert non-aws string to 
          
          this.xmldata = d.payload.xml;
          this.xmlfile = d.payload.xmlfile;
          this.dossier = parg.Params.dosid;
          this.viewXmlVisible = true;
          this.listLoading = false;
				});

			},
			
			
			// Toon nieuwe interface
			handleImport: function () {
        let parg = {};       
        parg.Params = {};
        parg.Params.sites = this.codes.sites;
        parg.Params.site = this.sitecode;
        parg.Params.period = this.periode;
        parg.Params.search = this.searchFilter;
        parg.Params.field = this.searchField;
        parg.Params.currentPage = this.currentPage;

        util.setSessionValue("site",this.sitecode);
        util.setSessionValue("period",this.periode);

        util.Forward(this.$router,"IMP",parg);
			},

			// uitgeven
			editSubmit: function () {
				this.$refs.editForm.validate((valid) => {
					if (valid) {
					  this.editLoading = true;
						
						let parg = Object.assign({}, this.editForm);

            if (this.editMode == "add") 
            {
							api.addRecord(parg).then((res) => {
                if (res.data.header.OK)
                  this.$notify({title: text.data.done, type: 'success',
								                message: text.getText("addOK",this.mainSubject,this.editForm.loaderversion)});
                else this.$notify({title: "Error",type: 'error',message: res.data.header.message});
		    				this.$refs['editForm'].resetFields();
        				this.editLoading = false;  
	  		    		this.editFormVisible = false;
   			 	  		this.getRecords();
	  					});
            }
						else {
							api.saveRecord(parg).then((res) => {		  					
                if (res.data.header.OK)
                  this.$notify({title: text.data.done, type: 'success',
								                message: text.getText("modOK",this.mainSubject,this.editForm.loaderversion)});
                else this.$notify({title: "Error",type: 'error',message: res.data.header.message});
						    this.$refs['editForm'].resetFields();
        				this.editLoading = false;  
	  		    		this.editFormVisible = false;
		    				this.getRecords();
	  					});
            }
					}
				});
			},

		},

		mounted() {

      window.addEventListener("popstate", (event) => {
        this.closeForm();
      });

      this.userDepts = sessionStorage.getItem("depts");
      this.userRoles = sessionStorage.getItem("roles");

    
      if (this.$route.params) {
        this.stack = this.$route.params;
        
        if (this.stack.Params)
        {
          this.sitecode = this.stack.Params.site;
          this.periode = this.stack.Params.period;
          this.searchFilter = this.stack.Params.search;
          this.searchField = this.stack.Params.field;
          this.currentPage = this.stack.Params.currentPage;
        }
        else {
          if (window.sessionStorage.getItem("site"))
            this.sitecode = window.sessionStorage.getItem("site"); // = util.setSessionValue("site");
          if (window.sessionStorage.getItem("period"))
            this.periode = window.sessionStorage.getItem("period"); //util.setSessionValue("period");
        }
      }
			
      this.related = settings.getRelated();
			this.getRecords();
		}
	}

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// dossierPaged.vue?3c361c54